<template>
  <div>
      <Header :home=false :logged="logged" :arealogada="true" />
      <DetalhesTitulo :tituloDetalhe=tituloSelecionado></DetalhesTitulo>
      <div class="text-center" v-if="loading" style="background: rgba(255, 255, 255, 0.7) none repeat scroll 0% 0%;width: 100%;height: 100%;position: absolute;display: block;z-index: 10002;margin: 0;top: 0;padding-top: 20%;">
        <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Text Centered"></b-spinner> <br><span style="color:#004E86">Processando Aguarde...</span>
      </div>
      
      <b-modal ref="confirmaSemCertificado" size="1x" title="Atenção" @ok="redirecionarInicio" no-close-on-backdrop no-close-on-esc>
        <template #modal-header=""><h5>Atenção</h5></template>
        Para utilizar o serviço de Consulta de Títulos, é necessário estar logado por meio de Certificado Digital ICP-Brasil
      </b-modal>

      <div id="painel" class="container-fluid">
        <b-row>
          <b-col cols="12" md="4" lg="3" v-if="logged" class="espaco-menu p-0">
            <Menu class="d-none d-xl-block" />
          </b-col>
          <b-col cols="12" md="8" lg="9" class="flex container-consulta-titulo p-0">
            <b-container fluid id="painelcontainerfluid">
                <b-form name="frmProcuracao" id="frmProcuracao">
                  <h4 class="text-primary mt-5">Consulta de Titulos</h4>
                  <hr>
                  <div>
                    <b-card>
                      <b-card-header>
                        <b-form-group>
                          <b-form-checkbox-group>
                            <b-form-checkbox
                              v-for="option in options"
                              v-model="selected"
                              :key="option.value"
                              :value="option.value"
                              class="b-custom-control-sm"
                              @change="exibeCampos(option.aggregate)"
                            >
                              <div style="width:170px">{{ option.text }}</div>
                            </b-form-checkbox>
                          </b-form-checkbox-group>
                        </b-form-group>
                      </b-card-header>
                      <b-card-text>
                        <div>
                          <b-form inline>
                            <b-input-group 
                              :prepend="selectedInput(selecionado).text" 
                              class="mb-2 mr-sm-2 mb-sm-0 mt-3"
                              v-for="selecionado in selectFiltrado"  
                              :key="'input' + selecionado"
                            >
                              <b-input
                                :placeholder="selectedInput(selecionado).text"
                                :type="selectedInput(selecionado).type"
                                v-model="selectedInput(selecionado).inputModel"
                                :state="selectedInput(selecionado).inputModel != null && selectedInput(selecionado).inputModel.length>1 && selectedInput(selecionado).inputModel != 'R$ '"
                                @keyup="executaFormatacao(selectedInput(selecionado),selectedInput(selecionado).format,$event)"
                              >
                                {{selecionado}}
                              </b-input>
                            </b-input-group>
                            <b-input-group 
                            :prepend="selectedInput(selectSelecionado).text"
                            v-for="selectSelecionado in selectSelected"
                            :key="'select' + selectSelecionado"
                            class="mb-2 mr-sm-2 mb-sm-0 mt-3"
                            >
                              <b-form-select 
                                :options="selectedInput(selectSelecionado).options"
                                :placeholder="selectedInput(selectSelecionado).text"
                                v-model="selectedInput(selectSelecionado).selectModel"
                                :value-field="selectedInput(selectSelecionado).valueFild"
                                :text-field="selectedInput(selectSelecionado).textFild"
                                :state="selectedInput(selectSelecionado).selectModel != null && selectedInput(selectSelecionado).selectModel.length>0"
                                @change="executaAlteracao(selectedInput(selectSelecionado).onChange)"
                              ></b-form-select>
                            </b-input-group>
                            <b-input-group 
                              prepend="comarca" 
                              v-if="selectSelected.indexOf('ipUfComarca')>=0"
                              class="mb-2 mr-sm-2 mb-sm-0 mt-3"
                            >
                              <b-form-select
                                :options="comarcas"
                                v-model="comarcaSelecionada"
                              ></b-form-select>
                            </b-input-group>
                          </b-form>
                      </div>
                      <div class="text-center" v-if="(selectFiltrado.length>0 || selectSelected.length>0)">
                        <b-button v-b-toggle.collapse-1 variant="primary" class="mt-4" @click="pesquisar"> 
                          <font-awesome-icon icon="search" /> Pesquisar
                        </b-button>
                        <div v-if="!loginComCertificado">
                          <b-alert variant="warning" :show="diasVencimentoConsulta > 0 && diasVencimentoConsulta < 3" class="mt-4">
                              <b>Atenção!</b> Falta(m) {{diasVencimentoConsulta}} dia(s) para expirar a consulta de titulo sem acesso com certificado digital
                          </b-alert>
                          <b-alert variant="danger" :show="diasVencimentoConsulta == 0" class="mt-4">
                              <b>Atenção!</b> Consulta de titulo sem acesso com certificado digital está prestes a expirar
                          </b-alert>
                        </div>
                      </div>
                      </b-card-text>
                    </b-card>
                  </div>
                </b-form>
                <b-table 
                  v-if="items.length>0"
                  id="my-table"
                  ref="selectableTable"
                  small
                  :items="items"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :fields="fields"
                  stacked="md"
                  striped 
                  hover
                  responsive="md"
                  class="textAnuencia"
                  >
                  <!-- formata o documento -->

                  <template slot="crt_descricao" slot-scope="row">
                    <a href="javascript:void(null)" class="infoT fontP">
                      {{row.item.crt_descricao | upper }}
                      <span>
                          {{row.item.crt_descricao}}
                      </span>
                    </a>
                  </template>
                  <template slot="nm_devedor" slot-scope="row">
                    <a href="javascript:void(null)" class="infoT fontP">
                      {{row.item.nm_devedor | upper }}
                      <span>
                          {{row.item.nm_devedor}}
                      </span>
                    </a>
                  </template>
                  <template slot="vl_protesto" slot-scope="row">
                      {{row.item.vl_protesto | moeda }}
                  </template>
                    <template slot="nm_ocorrencia" slot-scope="row">
                    <a href="javascript:void(null)" class="infoT fontP">
                      {{row.item.nm_ocorrencia | upper }}
                      <span>
                          {{row.item.nm_ocorrencia}}
                      </span>
                    </a>
                  </template>
                  <template slot="nm_arquivo" slot-scope="row">
                    <a href="javascript:void(null)" class="infoT fontP">
                      {{row.item.nm_arquivo | upper }}
                      <span>
                          {{row.item.nm_arquivo}}
                      </span>
                    </a>
                  </template>
                  <template #cell(eventos)="row">
                    <b-button @click="visualizarDetalhes(row.item)">
                      <font-awesome-icon icon="eye" />
                    </b-button>
                  </template>
                  
                </b-table>
                <p>
                  <b-pagination
                    v-if="items.length>0"
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                    aria-controls="my-table"
                  ></b-pagination>
                </p>
            </b-container>
          </b-col>
        </b-row>
      </div>
      <footersite class="d-none d-xl-block"></footersite>
      <footersitemobile class="d-block d-xl-none"></footersitemobile>
  </div>
</template>

<script>
    import Header from '../components/Header'
    import API from '../services/api'
    import Menu from '../template/Menu'
    import Serv from '../services'
    import DetalhesTitulo from '../components/Titulo/detalhesTitulo'
    import footersite from '../components/footersite'
    import footersitemobile from '../components/footersite/index_mobile'
    //import Modal from '../../components/modal/Confmodal'

    export default {
      components: {
        Header,
        Menu,
        DetalhesTitulo,
        footersite,
        footersitemobile
        //Modal,
      },
      data() {
          return {
            diasVencimentoConsulta:'',
            loginComCertificado: false,
            campoInput: '',
            selected: [], 
            options: [
              { text: 'Protocolo', value: 'ipProtocolo'},
              { text: 'Nome (devedor)', value: 'ipNomeDevedor'},
              { text: 'Chave única', value: 'ipChaveUnica' },
              { text: 'Número do Título', value: 'ipNumeroTitulo'},
              { text: 'Data do Protocolo', value: 'ipDataProtocolo', type:'date' },
              { text: 'Documento (devedor)', value: 'ipDocumentoDevedor'},
              { text: 'Ocorrência', value: 'ipDescOcorrencia', type:'select', aggregate:'ipDataOcorrencia', valueFild:'sg_ocorrencia', textFild:'nm_descricao', selectModel:'' },
              { text: 'Nosso número', value: 'ipNossoNumero'},
              //{ text: 'CNPJ Tronco (devedor)', value: 'ipTroncoDevedor', type:'number'},
              { text: 'Valor Protesto', value: 'ipVlProtesto', format:'formatReal', inputModel:'R$ '},
              { text: 'Data da Ocorrência', value: 'ipDataOcorrencia', type:'date', aggregate:'ipDescOcorrencia' },
              //{ text: 'Praça de Protesto', value: 'ipUfComarca', type:'select',onChange:'selecionaUf'},
            ],
            logged: false,
            carregaComarca: false,
            comarcas: [],
            comarcaSelecionada: '',
            ufSelecionada: '',
            loading: false,
            perPage: 10,
            currentPage: 1,
            items: [],
            fields: [
              { key: 'nm_nr_protocolo', label:'Protocolo', sortable: false, },
              { key: 'dt_protocolo_fmt', label:'Dt Protocolo', sortable: false },
              { key: 'crt_descricao', label:'Cartório', sortable: false },
              { key: 'nm_devedor', label:'Devedor', sortable: false },
              { key: 'vl_protesto', label:'Valor Protesto', sortable: false },
              { key: 'dt_ocorrencia_fmt', label:'Dt Ocorrência', sortable: true },
              { key: 'nm_ocorrencia', label:'Ocorrência', sortable: true },
              { key: 'nm_arquivo', label:'Arquivo', sortable: false },
              { key: 'eventos', label: 'Eventos', },
            ],
            tituloSelecionado:[],
            servicoProtesto: null,
          }
      },
      created: function (){
        let loginComCertifiicado = localStorage.getItem("sg_tipo_documento") && localStorage.getItem("SSL_CLIENT_S_DN_CN") && 
          localStorage.getItem("nm_tipo_certificado") && localStorage.getItem("SSL_CLIENT_S_DN") && localStorage.getItem("SSL_CLIENT_V_START") && localStorage.getItem("SSL_CLIENT_V_END"),
          docsExcecao = ['22055021826'],
          docSessao = localStorage.getItem('usrCpf')

        let govLogin = (localStorage.getItem('pxppwiru9') != undefined && localStorage.getItem('pxppwiru9') != null);
        let allowedGov = (govLogin ? ['2','3'].includes(localStorage.getItem("lhwvzhds3")) : false)

        if(govLogin){
          if(!allowedGov){
            this.$refs["confirmaSemCertificado"].show();
          }
        }
        else {
          this.getPermissao().then(() => {
            if (this.servicoProtesto == 0 ||
                (!loginComCertifiicado && docsExcecao.indexOf(docSessao) < 0)) {
                  this.$refs['confirmaSemCertificado'].show()
                } else{
                  this.$root.isLogged().then(() => {
                    this.logged = true
                  }).catch(() => {
                    this.logged = false
                  })
              }
          });
        }
      },
      mounted() {
        this.$root.isLogged().then(() => this.logged = true).catch(() => this.logged = false)
        const token = localStorage.getItem("jwtToken");
        
        API.post('titulos/ocorrencias', {token:token}).then(res => {
          this.$set(this.options.find(d => d.value == 'ipDescOcorrencia'), 'options',res.data.retorno)
        })
        API.get('uf').then(res => {
          this.$set(this.options.find(d => d.value == 'ipUfComarca'), 'options',res.data)
        })

        this.diasVencimentoConsulta =  localStorage.getItem('diasVencimento')
      },
      computed:{
          selectFiltrado(){
            let filtrado = []
            this.selected.forEach(element => {
              if(this.options.find( d => d.value == element).type != 'select')filtrado.push(element)
            });
            return filtrado
          },
          selectedInput() {
              return campo => this.options.find( d => d.value == campo)
          },
          selectSelected(){
            let selects = this.options.filter( d => d.type == 'select')
            let filtrado = []
            selects.forEach(element => {
              if(this.selected.includes(element.value))filtrado.push(element.value)
            });
            return filtrado;
          },
          rows() {
            return this.items.length
          }
      },
      filters: {
        documento: function (value) {
          if (value == null) {
              return '';
          } else {
              let v = value;
              //Remove tudo o que não é dígito
              v = v.replace(/\D/g, "");
              if (v.length < 14) { //CPF
                  //Coloca um ponto entre o terceiro e o quarto dígitos
                  v = v.replace(/(\d{3})(\d)/, "$1.$2");
                  //Coloca um ponto entre o terceiro e o quarto dígitos
                  //de novo (para o segundo bloco de números)
                  v = v.replace(/(\d{3})(\d)/, "$1.$2");
                  //Coloca um hífen entre o terceiro e o quarto dígitos
                  v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
              } else { //CNPJ
                  //Coloca ponto entre o segundo e o terceiro dígitos
                  v = v.replace(/^(\d{2})(\d)/, "$1.$2");
                  //Coloca ponto entre o quinto e o sexto dígitos
                  v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                  //Coloca uma barra entre o oitavo e o nono dígitos
                  v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
                  //Coloca um hífen depois do bloco de quatro dígitos
                  v = v.replace(/(\d{4})(\d)/, "$1-$2");
              }
              return v;
          }
        },
        dataHora: function (value) {
          if (value !== "" && value !== undefined && value !== null) {
            let date = new Date(value);
            return date.toLocaleDateString("pt-BR", {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
            });
          }
          return "";
        },
        Celular: function (value){
          var d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{5})(\d)/, "$1-$2")
          return d
        },
        Telefone: function (value){
          var d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{4})(\d)/, "$1-$2")
          return d
        },
        Moeda: function (v){
          /*var p = v.indexOf(".");
          v = v.slice(0, (p+3))
          v = v.replace(/\D/g,'');
          v = (v/100).toFixed(2) + '';
          */
          v = v.toString().replace(".", ",");
          v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,");
          v = v.replace(/(\d)(\d{3}),/g, "$1.$2,");
          return 'R$ ' + v;
        },
      },
      methods: {
        documento: function (event) {
            var value = event.target.value
            if (value == null) {
                return '';
            } else {
              let v = value;
              //Remove tudo o que não é dígito
              v = v.replace(/\D/g, "");
              if (v.length < 14) { //CPF
                  //Coloca um ponto entre o terceiro e o quarto dígitos
                  v = v.replace(/(\d{3})(\d)/, "$1.$2");
                  //Coloca um ponto entre o terceiro e o quarto dígitos
                  //de novo (para o segundo bloco de números)
                  v = v.replace(/(\d{3})(\d)/, "$1.$2");
                  //Coloca um hífen entre o terceiro e o quarto dígitos
                  v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
              } else { //CNPJ
                  //Coloca ponto entre o segundo e o terceiro dígitos
                  v = v.replace(/^(\d{2})(\d)/, "$1.$2");
                  //Coloca ponto entre o quinto e o sexto dígitos
                  v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
                  //Coloca uma barra entre o oitavo e o nono dígitos
                  v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
                  //Coloca um hífen depois do bloco de quatro dígitos
                  v = v.replace(/(\d{4})(\d)/, "$1-$2");
              }
              event.target.value = v;
          }
        },
        validarDocumento: function (event) {
            let documento = event.target.value.replace('.','').replace('.','').replace('-','').replace('/','')
            if(documento.length > 11){

              if(!Serv.validarCNPJ(documento))this.validation_documento_solicitante = false
              else this.validation_documento_solicitante = true
              
            }else{

              if(!Serv.validarCPF(documento))this.validation_documento_solicitante = false
              else this.validation_documento_solicitante = true

            }
        },
        formatReal(int)
        {
            var tmp = int+'';
            tmp = tmp.replace(/([0-9]{2})$/g, ",$1");
            if( tmp.length > 6 )
                    tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, ".$1,$2");

            return 'R$ ' + tmp;

        },
        executaFormatacao(input,nomeFuncao, event){
            if(nomeFuncao != null)
            {
              let numeroSemFormatar = event.target.value.replace(/[^\d]+/g,'')
              let numeroFormatado = this[nomeFuncao](numeroSemFormatar);
              this.$set(input, 'inputModel',numeroFormatado)
            }
        },
        exibeCampos(aggregate){
          if(aggregate != null) {
            setTimeout(() => {
              let indexArray = this.selected.indexOf(aggregate)
              if(indexArray<0)this.selected.push(aggregate)
              else this.selected.splice(indexArray,1)
            }, 1);
          }
        },
        pesquisar(){
          let travaPesquisa = false
          this.loading = true;
          const token = localStorage.getItem("jwtToken");
          let formBusca = {token:token}

          if(this.selectSelected.indexOf('ipUfComarca')<0)this.comarcaSelecionada=''
          this.selectFiltrado.forEach(element => {
            let vModel = this.options.find( d => d.value == element).inputModel
            if(!travaPesquisa && (vModel == undefined || vModel.length<= 1) )travaPesquisa = true
            else formBusca[element] = vModel;
          });

          this.selectSelected.forEach(element => {
            let vModel = this.options.find( d => d.value == element).selectModel
            if(!travaPesquisa && vModel == undefined )travaPesquisa = true
            else formBusca[element] = vModel;
          });

          if(!travaPesquisa)
          {
            let self = this
            API.post('titulos/pesquisa', formBusca).then(res => {
              self.loading = false;
              if(res.data.length>0)self.items = res.data
              else 
              {
                self.items = []
                alert('Nenhum título localizado')
              }
            })
              
          }
          else 
          {
            this.loading = false;
            alert('Preencha todos os filtros selecionados.')
          }
        },
        executaAlteracao(nomeFuncao){
          if(nomeFuncao != null)this[nomeFuncao]();
        },
        selecionaUf(){
          this.loading = true
          let self = this
          this.ufSelecionada = this.options.find( d => d.value == 'ipUfComarca').selectModel;
          API.get('municipios?iduf=' + this.ufSelecionada).then(res => {
            this.comarcas = res.data
            self.loading = false
            self.carregaComarca = true
          })
        },
        async visualizarDetalhes(tituloDetalhe){
            this.loading = true
            this.tituloSelecionado = tituloDetalhe
            let self = this
            const token = localStorage.getItem("jwtToken");
            
            await API.post('titulos/detalhe',{token: token, nm_chave : tituloDetalhe.nm_chave, cd_importacao_arquivo: tituloDetalhe.cd_importacao_arquivo}).then(res => {
            self.$set(self.tituloSelecionado, 'devedores', res.data.dados)
          })

          await API.post('titulos/historico',{token: token, nm_chave : tituloDetalhe.nm_chave}).then(res => {
            self.$set(self.tituloSelecionado, 'historicos', res.data)
          })

          await API.post('titulos/listaAnuencia',{token: token, cd_titulo : tituloDetalhe.cd_titulo}).then(res => {
            self.$set(self.tituloSelecionado, 'listaAnuencia', res.data)
            self.loading = false
            self.$bvModal.show('modal-detalhestitulo');
          })
          
        },
        async getPermissao() {
          const token = localStorage.getItem('jwtToken'),
            permissao = await API.post('usuario/getPermicaoServico', { token })
          
          this.servicoProtesto = permissao.data[0].servico_protesto
        },
        redirecionarInicio() {
          this.$router.push({ name: 'painel' })
        }
      },
    }
</script>

<style scoped>
#wrapper-spinner { position: absolute; left: 0px; bottom: 0px; width: 100%; height: calc(100% - 80px); }
#wrapper-spinner .v-spinner { position: absolute; left: 50%; top: 50%; margin: -10px 0px 0px -20px; }
#painel { position: fixed; width: 100%; left: 0px; bottom: 0px; padding-top: 0px; height: calc(100% - 80px); overflow-x: hidden; border-top: 1px solid #f1f1f1; }
.lista-certidoes { color: #000; }
.lista-certidoes b { font-size: 0.85rem; color: var(--main-azul); }
a { color: #555; }
.shadow { box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important; }
#loading-solicitante { vertical-align: 0; margin-left: -21px; }
.load{ top: 50%; display: flex; justify-content: center; align-items: center; }
.spin { background: #fff; height: 80px; width: 80px; border-radius: 50vh; border-color: #209CEE; border-top: 5px solid  #209CEE; animation: loading 3s linear infinite; }
.loading{ position: absolute; color: #000; } @keyframes loading{ 100%{ transform: rotate(360deg)} }
.bold{ font-weight: bold; }
.mensagemErro{ color: red; }
#cabecalho{ z-index: 0 !important; }
.espaco-menu{width: calc(296px + 5px + 5px);flex: unset;margin-left: calc(3.8vw - 5px);}

#painel{scrollbar-width:none;}
#painel::-webkit-scrollbar{display:none;}
#painel h1 {text-align: left;font: normal normal bold 30px/41px 'Kanit', sans-serif; letter-spacing: 0px;color: #597EB5;margin-bottom: 22px;}
#painelcontainerfluid{margin-top: 37px;}
@media (max-width:1600px) and (min-width:1400px){
  .espaco-menu{margin-left: calc(20px - 5px) !important;}  
  #painelcontainerfluid{padding-right: 20px !important;}
}
@media (max-width:1399px) and (min-width:1200px){
  .espaco-menu{margin-left: calc(10px - 5px) !important;}
  #painelcontainerfluid{padding-right: 10px !important;}
}
@media (max-width:1199px){
  #painel {padding:0 17px;}
  #painel > .row{
    width: 100%;
    /* max-width: none; */
    margin: 0 !important;
    padding: 0px !important;
    margin-bottom: 70px !important;
    /* margin-left: -17px !important; */
    max-width: 100%;
    margin-left: 0px !important;
  }
  .col-lg-9{max-width: none;flex: 1 1 100%;padding: 0;}
  #painelcontainerfluid{padding:0px !important;}
}
@media (max-width:1700px) and (min-width:1300px){
  #painel .container-consulta-titulo{margin-left: 1vw;}
}
@media (max-width:1300px) and (min-width:1200px){
  #painel .container-consulta-titulo{
    margin-left: 310px;
    max-width: calc(100vw - 310px);}
}
@media (max-width:1199px) {
  #painel .container-consulta-titulo{
    margin:0 auto !important;
    max-width: calc(100vw - 20px);}
}
</style>
